export const getKey = (
	item?: { key?: string } | string,
): string | undefined => {
	if (typeof item === 'string') {
		return item;
	}
	return item?.key ?? undefined;
};
